import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Box, Chip, Grid, IconButton, Stack, Typography } from "@mui/material";
import CardImageUploader from "components/CardImageUploader";
import Field from "components/Field";
import { required } from "components/Field/validate";
import TitleHeader from "components/TitleHeader";
import WysiwygEditor from "components/WysiwygEditor";
import { connect } from "formik";
import { muscle } from "../../../utils/gym.utils";
import { programTagGroups } from "../../../utils/programs.utils";
import { useSelector } from "react-redux";

const DetailProgram = ({
  formik,
  editorValue,
  setEditorValue,
  savedEditorValue,
  disabled = false,
}) => {
  const { values, setFieldValue } = formik;
  const { type } = useSelector((state) => state.user.userDetails);
  const isReadOnly = disabled;

  return (
    <>
      <Grid container spacing={5}>
        <Grid item sm={6} xs={12}>
          <TitleHeader el="h3" mb={3} title="Details" fw={600} fs={16} />
          <Box pr={5} sx={{ borderRight: "1px solid #E0E4EA" }}>
            <Field
              variant="outlined"
              type="text"
              label="Titre du programme"
              placeholder="Entrer un titre"
              name="name"
              disabled={isReadOnly}
              validate={required}
              mb={4}
            />
            <Grid container spacing={2}>
              <Grid item sm={9} xs={12} sx={{ display: type?.toUpperCase() === 'ADMIN' || isReadOnly ? 'none' : 'block' }}>
                <Field
                  variant="outlined"
                  type="date"
                  label="Date de début"
                  placeholder="Date de début"
                  name="start_date"
                  validate={type?.toUpperCase() === 'ADMIN' || isReadOnly ? undefined : required}
                  mb={4}
                />
              </Grid>
              <Grid item sm={type?.toUpperCase() === 'ADMIN' || isReadOnly ? 12 : 3} xs={12}>
                <Field
                  type="number"
                  label="Semaines"
                  placeholder="0"
                  name="program_weeks"
                  size="small"
                  disabled={isReadOnly}
                  sx={{ ".MuiInputBase-input": { textAlign: "center" } }}
                  validate={required}
                  min={1}
                  InputProps={{
                    startAdornment: (
                      <IconButton
                        edge="start"
                        onClick={() =>
                          setFieldValue(
                            "program_weeks",
                            values.program_weeks - 1
                          )
                        }
                        disabled={isReadOnly}
                      >
                        <RemoveIcon />
                      </IconButton>
                    ),
                    endAdornment: (
                      <IconButton
                        edge="end"
                        onClick={() =>
                          setFieldValue(
                            "program_weeks",
                            values.program_weeks + 1
                          )
                        }
                        disabled={isReadOnly}
                      >
                        <AddIcon />
                      </IconButton>
                    ),
                  }}
                />
              </Grid>
            </Grid>
            <Field
              type="multiselect"
              label="Zones ciblées"
              placeholder="Sélectionner un muscle"
              name="primary_muscle"
              disabled={isReadOnly}
              notched={true}
              options={muscle}
            />
            <Box sx={{ pointerEvents: isReadOnly ? 'none' : 'auto', opacity: isReadOnly ? 0.6 : 1 }}>
              <WysiwygEditor
                editorValue={editorValue}
                setEditorValue={setEditorValue}
                savedEditorValue={savedEditorValue}
              />
            </Box>
          </Box>
        </Grid>
        <Grid item sm={6} xs={12}>
          <TitleHeader el="h3" mb={3} title="Media" fw={600} fs={16} />
          <Box mb={2} sx={{ fontSize: "12px", fontWeight: "600" }}>
            Affiche du programme
          </Box>
          <CardImageUploader
            name="thumbnail"
            libraryApi="/api/coach/programs/image/library"
            view="portrait"
            label={
              values.thumbnail ? "Changer la affiche" : "Ajouter une affiche"
            }
            apiKey="/api/upload/coach/thumbs/program/new_thumb"
            thumbnail={values ? values.thumbnail : null}
            disableAction={!isReadOnly}
            disabled={isReadOnly}
            validationMsg="JPEG ou PNG, max 5Mo. Format portrait recommandé (ex : 800×1000px, ratio 4:5)."
          />
          {/* Tag selector */}
          <Box mt={4}>
            <Typography fontSize="14px" fontWeight={600} color="#111111" mb={2}>
              Tags
            </Typography>
            <Stack gap={2}>
              {programTagGroups.map((group) => {
                const currentTags = values.tags || [];
                const toggleTag = (tag) => {
                  const next = currentTags.includes(tag)
                    ? currentTags.filter((t) => t !== tag)
                    : [...currentTags, tag];
                  setFieldValue("tags", next);
                };
                return (
                  <Box key={group.key}>
                    <Typography fontSize="11px" fontWeight={600} color="#7A7A7A" textTransform="uppercase" mb={1}>
                      {group.label}
                    </Typography>
                    <Stack direction="row" flexWrap="wrap" gap={1}>
                      {group.tags.map((tag) => {
                        const selected = currentTags.includes(tag);
                        return (
                          <Chip
                            key={tag}
                            label={tag}
                            onClick={() => !isReadOnly && toggleTag(tag)}
                            variant={selected ? "filled" : "outlined"}
                            sx={{
                              fontSize: "12px",
                              fontWeight: selected ? 600 : 400,
                              backgroundColor: selected ? "#0001FC" : "transparent",
                              color: selected ? "#ffffff" : "#4F5668",
                              borderColor: selected ? "#0001FC" : "#E0E4EA",
                              cursor: isReadOnly ? "default" : "pointer",
                              "&:hover": isReadOnly ? {} : {
                                backgroundColor: selected ? "#0001CC" : "#E4EAFC",
                                borderColor: "#0001FC",
                                color: selected ? "#ffffff" : "#0001FC",
                              },
                            }}
                          />
                        );
                      })}
                    </Stack>
                  </Box>
                );
              })}
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default connect(DetailProgram);
